import React from "react"

export const SignContractWizardContext = React.createContext({})
